import { render, staticRenderFns } from "./CollegeAchievement.vue?vue&type=template&id=2eff31c5&scoped=true&lang=html&"
import script from "./CollegeAchievement.vue?vue&type=script&lang=js&"
export * from "./CollegeAchievement.vue?vue&type=script&lang=js&"
import style0 from "./CollegeAchievement.vue?vue&type=style&index=0&id=2eff31c5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eff31c5",
  null
  
)

export default component.exports